import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { IntroComponent } from './intro/intro.component';
import { PagesRoutingModule } from './pages-routing.module';

@NgModule({
  imports: [
    SharedModule,
    PagesRoutingModule
  ],
  declarations: [
    IntroComponent
  ]
})
export class PagesModule { }



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/pages/pages.module.ts